const initialized = new WeakSet();
const mobile = matchMedia('(max-width: 749px)');
function initialize(bar) {
  if (initialized.has(bar)) return;
  const section = bar.closest('.shopify-section');
  const info = section?.querySelector('.product-information[data-elena-mobile]');
  const fit = info?.querySelector('.elena-fit');
  const buy = info?.querySelector('.buy-buttons-block');
  if (!info || !fit || !buy) return;
  initialized.add(bar);
  const chosenSizes = new Map();
  let variantPending = false;
  let selectionGeneration = 0;
  function sizeOptions() {
    return Array.from(info.querySelectorAll('variant-picker input[data-option-name]')).filter(input => /size/i.test(input.dataset.optionName));
  }
  function sizeNames() {
    return [...new Set(sizeOptions().map(input => input.dataset.optionName))];
  }
  let queued = false;
  let reordered = false;
  const marker = document.createTextNode('');
  fit.before(marker);
  const guide = fit.querySelector('.elena-fit__header a')?.cloneNode(true);
  const fitAccordion = document.createElement('details');
  fitAccordion.className = 'elena-mobile-fit-details';
  const fitSummary = document.createElement('summary');
  fitSummary.textContent = fit.querySelector('.elena-fit__header strong')?.textContent || '';
  fitAccordion.append(fitSummary);
  Array.from(fit.children).forEach(child => {
    if (!child.classList.contains('elena-fit__header')) fitAccordion.append(child);
  });
  fit.append(fitAccordion);
  let fitMobileMode;
  if (guide) {
    guide.className = 'elena-mobile-guide';
    guide.hidden = true;
    buy.before(guide);
    guide.addEventListener('click', () => {
      fit.querySelectorAll('details').forEach(details => {details.open = true;});
    });
  }
  const delivery = document.createElement('p');
  delivery.className = 'elena-mobile-delivery';
  const preOrderNote = info.querySelector('.elena-product-info .rte > p')?.textContent.trim();
  delivery.textContent = info.dataset.preorder === 'true' && preOrderNote && /expected delivery|dispatch|ships/i.test(preOrderNote) && preOrderNote.length < 240 ? preOrderNote : info.dataset.delivery;
  delivery.hidden = true;
  buy.after(delivery);
  function sizeControls() {
    const wizard = info.querySelector('.rio-options');
    const sizes = sizeOptions().map(e => e.value);
    if (wizard) return Array.from(wizard.querySelectorAll('[data-option-value]')).find(e => sizes.includes(e.dataset.optionValue));
    return sizeOptions()[0];
  }
  function chooseSize() {
    const target = sizeControls();
    if (!target) return;
    target.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'center'});
    target.focus({preventScroll: true});
  }
  function ready() {
    if (variantPending) return false;
    const names = sizeNames();
    if (!names.length) return true;
    const checked = sizeOptions().filter(input => input.checked);
    if (!names.every(name => chosenSizes.has(name) && checked.some(input => input.dataset.optionName === name && input.value === chosenSizes.get(name)))) return false;
    const title = bar.querySelector('.sticky-add-to-cart__variant')?.textContent.trim() || '';
    const values = title.split('/').map(value => value.trim());
    if (!Array.from(chosenSizes.values()).every(value => values.includes(value))) return false;
    const urlVariant = new URL(location.href).searchParams.get('variant');
    return checked.some(input => input.dataset.variantId === bar.dataset.currentVariantId) || urlVariant === bar.dataset.currentVariantId;
  }
  bar.elenaCanAdd = () => !mobile.matches || Boolean(ready());
  bar.elenaChooseSize = chooseSize;
  function sync() {
    queued = false;
    if (!bar.isConnected) {observer.disconnect(); return;}
    if (fitMobileMode !== mobile.matches) {
      fitAccordion.open = !mobile.matches;
      fitMobileMode = mobile.matches;
    }
    if (mobile.matches && !reordered) {
      delivery.after(fit);
      info.querySelector('.elena-product-info details')?.removeAttribute('open');
      reordered = true;
    } else if (!mobile.matches && reordered) {
      marker.after(fit);
      reordered = false;
    }
    if (guide) guide.hidden = !mobile.matches || !sizeNames().length;
    fit.hidden = mobile.matches && !sizeNames().length;
    delivery.hidden = !mobile.matches || info.dataset.giftCard === 'true';
    if (!mobile.matches) return;
    const wizard = info.querySelector('.rio-options');
    if (wizard) {
      const groups = Array.from(wizard.querySelectorAll('[data-option]'));
      const groupedColours = groups.some(group => Array.from(group.querySelectorAll('[data-option-value]')).some(swatch => /^\d+$/.test(swatch.dataset.optionValue || '')));
      groups.forEach(group => {
        const wrapper = group.parentElement?.parentElement;
        const title = wrapper?.querySelector('.rio-product-option-title');
        const swatches = Array.from(group.querySelectorAll('[data-option-value]'));
        if (groupedColours && /^colou?r$/i.test(title?.textContent.trim() || '') && swatches.length === 1 && !/^\d+$/.test(swatches[0].dataset.optionValue || '')) wrapper.parentElement.classList.add('elena-duplicate-colour');
        swatches.forEach(swatch => {
          if (/^\d+$/.test(swatch.dataset.optionValue || '')) swatch.classList.add('elena-colour-swatch');
        });
        if (guide && /^size$/i.test(title?.textContent.trim() || '')) {
          const heading = title.parentElement;
          heading.classList.add('elena-size-heading');
          heading.parentElement.classList.add('elena-size-heading-container');
          heading.parentElement.parentElement.classList.add('elena-size-heading-container');
          if (guide.parentElement !== heading) heading.append(guide);
        }
      });
      const sizes = sizeOptions().map(input => input.value);
      wizard.querySelectorAll('[data-option-value]').forEach(swatch => {
        if (!sizes.includes(swatch.dataset.optionValue)) return;
        const selected = chosenSizes.get(sizeNames()[0]) === swatch.dataset.optionValue;
        swatch.setAttribute('aria-pressed', String(selected));
        swatch.style.setProperty('background-color', selected ? '#000' : '#fff', 'important');
        swatch.style.setProperty('border-color', selected ? '#323232' : '#dcdcdc', 'important');
        swatch.querySelectorAll('span[style]').forEach(span => span.style.setProperty('color', selected ? '#fff' : '#000', 'important'));
      });
    } else {
      const legend = sizeOptions()[0]?.closest('fieldset')?.querySelector('legend');
      if (guide && legend) {
        legend.classList.add('elena-size-heading');
        if (guide.parentElement !== legend) legend.append(guide);
      }
      sizeOptions().forEach(input => {
        if (!chosenSizes.has(input.dataset.optionName)) {
          input.checked = false;
          input.removeAttribute('checked');
        }
      });
    }
    const target = info.querySelector('product-form-component [ref="addToCartButton"]');
    const button = bar.querySelector('[ref="addToCartButton"]');
    const label = button?.querySelector('.add-to-cart-text__content > span');
    if (!target || !button || !label) return;
    const selected = ready();
    info.querySelectorAll('.accelerated-checkout-block').forEach(checkout => {
      checkout.style.setProperty('display', selected ? '' : 'none', selected ? '' : 'important');
    });
    const waiting = variantPending && sizeNames().every(name => chosenSizes.has(name));
    const disabled = waiting || (selected ? target.disabled : false);
    if (button.disabled !== disabled) button.disabled = disabled;
    const chooseLabel = sizeNames().length > 1 ? bar.dataset.chooseSizes : bar.dataset.chooseSize;
    const text = waiting ? bar.dataset.updating : !selected ? chooseLabel : target.disabled ? target.textContent.trim() : bar.dataset.addToBag;
    if (label.textContent !== text) label.textContent = text;
    const busy = String(waiting);
    if (target.getAttribute('aria-busy') !== busy) target.setAttribute('aria-busy', busy);
    if (button.getAttribute('aria-busy') !== busy) button.setAttribute('aria-busy', busy);
    if (!target.disabled) {
      const mainLabel = Array.from(target.childNodes).find(node => node.nodeType === Node.TEXT_NODE && node.textContent.trim());
      const mainText = waiting ? bar.dataset.updating : selected ? bar.dataset.addToBag : chooseLabel;
      if (mainLabel && mainLabel.textContent.trim() !== mainText) mainLabel.textContent = mainText;
    }
    const quantity = bar.querySelector('[ref="quantityDisplay"]');
    if (!selected && quantity?.style.display !== 'none') quantity.style.display = 'none';
  }
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(sync);
  }
  section.addEventListener('click', event => {
    if (!mobile.matches || !(event.target instanceof Element)) return;
    const swatch = event.target.closest('[data-option-value]');
    const input = event.target.closest('input[data-option-name]');
    if (swatch && swatch.closest('.rio-options')) {
      const sizes = sizeOptions().map(e => e.value);
      if (sizes.includes(swatch.dataset.optionValue) && swatch.getAttribute('aria-disabled') !== 'true' && sizeNames().length === 1) chosenSizes.set(sizeNames()[0], swatch.dataset.optionValue);
      else if (/^\d+$/.test(swatch.dataset.optionValue || '')) chosenSizes.clear();
      schedule();
    } else if (input && /size/i.test(input.dataset.optionName)) {chosenSizes.set(input.dataset.optionName, input.value); schedule();}
    if (event.target.closest('.sticky-add-to-cart__button') || event.target.closest('product-form-component [ref="addToCartButton"]')) {
      if (!ready()) {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (!variantPending) chooseSize();
      }
    }
  }, true);
  section.addEventListener('elena:variant-loading', event => {
    const generation = ++selectionGeneration;
    variantPending = true;
    schedule();
    event.detail.promise.catch(() => {}).finally(() => {
      if (generation !== selectionGeneration) return;
      variantPending = false;
      schedule();
    });
  });
  section.addEventListener('keydown', event => {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    const swatch = event.target.closest?.('[data-option-value]');
    if (swatch && swatch.closest('.rio-options')) {
      const sizes = sizeOptions().map(e => e.value);
      if (sizes.includes(swatch.dataset.optionValue) && sizeNames().length === 1) {chosenSizes.set(sizeNames()[0], swatch.dataset.optionValue); schedule();}
    }
  }, true);
  section.addEventListener('change', event => {
    const input = event.target;
    if (input instanceof HTMLInputElement && /size/i.test(input.dataset.optionName || '')) {chosenSizes.set(input.dataset.optionName, input.value); schedule();}
  }, true);
  const observer = new MutationObserver(schedule);
  observer.observe(section, {childList: true, subtree: true, attributes: true, attributeFilter: ['disabled','value','data-current-variant-id','data-stuck']});
  mobile.addEventListener('change', schedule);
  sync();
}
function scan() {
  document.querySelectorAll('sticky-add-to-cart[data-elena-mobile]').forEach(initialize);
}
scan();
new MutationObserver(records => {
  const added = records.flatMap(record => Array.from(record.addedNodes));
  added.forEach(node => {
    if (!(node instanceof Element)) return;
    if (node.matches('sticky-add-to-cart[data-elena-mobile]')) initialize(node);
    node.querySelectorAll('sticky-add-to-cart[data-elena-mobile]').forEach(initialize);
  });
}).observe(document.body, {childList: true, subtree: true});


